<template lang="pug">
    Modal
        .form
            h2  Add a New Localized Content Record to Product Group
            .form__control-group.rule__control-group--select
                label Select New Locale
                select.form__select(
                    v-model="newLocale"
                )
                    option(
                        v-for="market in getAvailableMarkets"
                    ) {{market.locale}}
            button.button__submit(
                @click="submit"
            ) Add Locale Record To Product
</template>
<script>
import Modal from '../general/Modal';
import store from '../../store';
import Services from '../../services/Services';
import { postResource } from '../../services/Utils.js';
import VueNotifications from 'vue-notifications';
export default {
    name: 'CreateProductLocalRecord',
    components: {
        Modal
    },
    data() {
        return {
            newLocale: '',
        }
    },
    computed: {
        getActiveProduct() {
            return store.getters.getActiveProduct;
        },
        getAvailableMarkets() {
            return store.getters.getMarkets;
        }
    },
    notifications: {
        showSuccessMsg: {
        type: VueNotifications.types.success,
        title: '',
        icon: '✅'
        },
        showErrorMsg: {
        type: VueNotifications.types.error,
        title: '',
        icon: '❗️'
        }
    },
    mounted(){
        Services.getMarkets();
    },
    methods: {
        submit(){
            let newRecord = {
                recordId: this.getActiveProduct._id,
                recordType: 'Product',
                locale: this.newLocale
            }

            postResource('/v1/products/addLocalRecord', false, newRecord)
                .then(res => {
                    console.log('success!', res);
                    this.showSuccessMsg({ message: `New ${this.newLocale} record added to ${this.getActiveProduct.title}!` });
                    store.commit('hideModals', true);
                    Services.setActiveProduct(this.getActiveProduct._id, this.$router.push(`/products/${this.getActiveProduct._id}`));
                    return res;
                })
                .catch(error => {
                    let message = 'An error occurred. Please try again.';
                    if(error.error){
                        message = error.error;
                    }
                    this.showErrorMsg({
                    message
                    });
                });
        }
    }
}
</script>
<style lang="scss" scoped>
h2 {
    text-align: center;
}

.form {
    padding: 2rem;
}

.form__control-group.rule__control-group--select:after {
    top: 20px;
}

button {
    margin: 2rem auto 0;
}
</style>



// WEBPACK FOOTER //
// src/components/modals/CreateProductLocalRecord.vue